module.exports = __webpack_public_path__ + "img/settings.acc2f8c5.png";